import styled from "styled-components";

import breakpoints from "core/breakpoints";
import { regular as regularFont, medium as mediumFont } from "core/fontStyles";
import { convertPxToRem } from "frontend/components/helpers";
import Button from "core/Button";
import colors from "core/colors";
import { rapidEasing } from "core/animation";

export const Title = styled.div`
    display: flex;
    margin-bottom: ${convertPxToRem({ px: 8 })};
    font-size: ${convertPxToRem({ px: 24 })};

    h1 {
        flex: 1 0;
    }

    button {
        flex: 0 0;
        border: none;
        background: none;
        cursor: pointer;

        path {
            transition: fill ${rapidEasing};
        }

        &:hover path {
            fill: ${colors.accent.lightMode.persian};
        }
    }

    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        display: none;
    }
`;

export const PhotoName = styled.div`
    margin-bottom: ${convertPxToRem({ px: 24 })};
    display: flex;
    color: ${colors.secondary.orca};

    p {
        ${regularFont}
        font-style: italic;
        font-size: ${convertPxToRem({ px: 16 })};
        line-height: ${convertPxToRem({ px: 24 })};
        margin-top: ${convertPxToRem({ px: 2 })};
        margin-left: ${convertPxToRem({ px: 7 })};
    }

    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        display: none;
    }
`;

export const Buttons = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: ${convertPxToRem({ px: 24 })};
`;

export const ContinueButton = styled(Button).attrs({
    styleType: "cta",
    darkMode: true
})`
    flex: 1 0;
`;

export const CancelButton = styled(Button).attrs({ styleType: "outline" })`
    flex: 1 0;
    border-width: 2px;
    margin-left: ${convertPxToRem({ px: 16 })};

    @media (min-width: ${breakpoints.tablet.rem}) {
        display: none;
    }
`;

export const Note = styled.p`
    display: flex;
    margin-top: ${convertPxToRem({ px: 16 })};
    line-height: ${convertPxToRem({ px: 19.2 })};
    color: ${colors.secondary.orca};
    ${mediumFont}

    &:first-of-type {
        margin-top: ${convertPxToRem({ px: 32 })};
    }

    span {
        flex: 1 1;
        margin-left: ${convertPxToRem({ px: 19 })};
    }

    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        display: none;
    }
`;
